module.exports = __webpack_public_path__ + "static/media/search.2dcd9110.svg";